import React from 'react'
import PropTypes from 'prop-types'

import withProviders from '../../../contexts/withProviders'
import AccountingProviderReconnect from './AccountingProviderReconnect'

const DisconnectionSupplierScreen = ({
  reauth,
  accountingProvider,
  companyFileMissing,
}) => {
  if (reauth !== true) {
    window.location.href = '/dashboard'
  }

  return (
    <AccountingProviderReconnect
      accountingProvider={accountingProvider}
      companyFileMissing={companyFileMissing}
    />
  )
}

DisconnectionSupplierScreen.propTypes = {
  reauth: PropTypes.bool.isRequired,
  accountingProvider: PropTypes.string.isRequired,
  companyFileMissing: PropTypes.bool,
}

DisconnectionSupplierScreen.defaultProps = {
  companyFileMissing: false,
}

export default withProviders(DisconnectionSupplierScreen)
